module.exports = __webpack_public_path__ + "files/b013682026757f69871dbe931d0779c8.svg";